import { useState, useCallback } from 'react';

import useArticles from '../../../api/comocat/useArticles';

export const ProductSelect = (props:any) => {
	const [search, setSearch] = useState('');
	const { onSelect } = props;
	const { articles, isLoading } = useArticles();
	const productList = articles ? Object.values(articles).map((a: any) => ({
		article: 'its a article',
		code: a?.article?.S?.code || a?.article?.W?.code,
		name: a?.article?.S?.description?.nl || a?.article?.W?.description?.nl || '',
	})) : [];

	const filteredProducts = productList.filter((p: any) => {
		if (!search) return true;
		const term = search.toLowerCase();
		return String(p?.name).toLowerCase().includes(term) || String(p?.code).toLowerCase().includes(term);
	});

	const handleSelect = useCallback((p: any) => {
		onSelect(p);
	}, [onSelect]);

	return (
		<div style={{ minWidth: '240px', margin: '0 auto' }}>
			<input
				type="text"
				placeholder="Zoek product..."
				value={search}
				onChange={e => setSearch(e.target.value)}
				style={{
					marginBottom: '1rem', width: '100%', padding: '0.5rem', borderRadius: '14px', border: '1px solid #ccc'
				}}
			/>
			{isLoading ? (
				<div style={{ textAlign: 'center', margin: '1rem 0' }}>Laden...</div>
			) : (
				<ul style={{
					listStyle: 'none', padding: 0, overflowY: 'auto', maxHeight: '300px'
				}}>
					{filteredProducts?.map((p: any) => (
						<li
							key={p.code}
							style={{
								padding: '0.5rem',
								borderBottom: '1px solid #eee',
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								cursor: 'pointer'
							}}
							onClick={() => handleSelect(p)}
						>
							<div>
								<strong>{p.name}</strong> <span style={{ color: '#888' }}>({p.code})</span>
							</div>
						</li>
					))}
				</ul>
			)}
		</div>
	);
};
